import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { Meldung } from '../meldung';

@Component({
    selector: 'kiene-meldung-details-dialog',
    templateUrl: './meldung-details-dialog.component.html',
    styleUrls: ['./meldung-details-dialog.component.css'],
})
export class MeldungDetailsDialogComponent implements OnInit {
    meldung = new Meldung();
    fehlerArray: string[] = [];

    constructor(
        public dialogRef: MatDialogRef<MeldungDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        private readonly router: Router,
    ) {
        if (this.data && this.data.meldung) {
            this.meldung = this.data.meldung;
        }
    }

    ngOnInit(): void {
        if (this.meldung.fehler) {
            this.fehlerArray = this.meldung.fehler.split(';');
        }
    }

    getStatusColor() {
        if (KieneUtils.includesId([112, 115, 116], this.meldung.status_id)) {
            return '#8cb369';
        }
        if (KieneUtils.sameId(this.meldung.status_id, 113)) {
            return '#bc4b51';
        }
        return 'black';
    }

    gotoAbgabebeleg() {
        if (!this.meldung?.abgabebeleg_id) {
            return;
        }
        this.dialogRef.close();
        this.router.navigate(['/belege/abgabebelege', this.meldung.abgabebeleg_id]).then();
    }

    getStatusIcon() {
        if (KieneUtils.includesId([112, 115, 116], this.meldung.status_id)) {
            return 'check_circle';
        }
        if (KieneUtils.sameId(this.meldung.status_id, 113)) {
            return 'error';
        }
        return 'circle';
    }
}
